var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLandlineType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 152",
    d: "M9.28087 8.3664L8.03015 9.11628C7.82043 9.24202 7.7314 9.50149 7.82939 9.72553C9.37613 13.2619 12.6667 16.0749 14.1667 16.6622C14.59 16.828 15.3333 16.3291 15.8333 15.4964C16.6807 14.0852 18 14.8302 19.277 15.3338C20.3995 15.7765 20.8874 16.3853 20.9429 16.828C21.1095 18.1562 21.0096 20.8457 19.277 20.9785C17.5444 21.1113 14.944 20.6024 13.8333 20.1597C8.61485 18.4942 5.00525 12.5668 4.11675 10.1872C3.17271 7.91817 1.95101 3.31374 4.61654 3.04811C7.28208 2.78248 8.34976 3.67139 8.61485 4.37628C9.10579 5.68121 10.1294 7.44171 9.37562 8.29018C9.34863 8.32055 9.31571 8.3455 9.28087 8.3664Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLandlineType);
export default __webpack_public_path__ + "static/media/ic_landline_type.34a3f9005d4bef2d6d3ceb8f9df25b58.svg";
export { ForwardRef as ReactComponent };